// extracted by mini-css-extract-plugin
export default {"container":"Pricing_container__qQc6M"};